export class CheckListModel {
  AttacheAId: number;
  elements: ItemCheckListModel[];
}

export class ItemCheckListModel {
  libelle: string;
  estCoche: boolean;
}

export class ItemCheckListChangeModel {
  order: number;
  libelle: string;
  estCoche: boolean;
}
